/* =========================================================
   佐渡産おけさ柿LP 特別インタラクション (sk-lp-kaki.js)
   - Scroll reveal (IntersectionObserver 3段フェイルセーフ)
   - Hero parallax (0.35x Drift)
   - FAQ accordion (<details> ネイティブ + 排他制御)
   - Smooth anchor scroll (-24px オフセット)
   - Shopify Cart API 連携 (非同期カート追加 + ミニカートオープン)
   ========================================================= */

(function () {
  'use strict';

  // 各 sk-lp-kaki-* セクションがこのスクリプトを個別に読み込むため、
  // 同じページで複数回実行される。初期化を1回に限定し、
  // クリックハンドラーの重複登録（1クリックで複数個カート追加）を防ぐ。
  if (window.__skLpKakiInitialized) return;
  window.__skLpKakiInitialized = true;

  /* ---------------------------------------------------------
     1. Reveal on scroll
     JS が動かない環境や沈黙した場合に備え、保険を多段で用意
     --------------------------------------------------------- */
  function initReveal() {
    var revealEls = document.querySelectorAll('.reveal');
    if (!revealEls.length) return;

    function showAll() {
      Array.prototype.forEach.call(revealEls, function (el) {
        el.classList.add('is-visible');
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });

      Array.prototype.forEach.call(revealEls, function (el) { io.observe(el); });

      // 保険A: 初期表示で既にビューポート内の要素は即表示
      requestAnimationFrame(function () {
        Array.prototype.forEach.call(revealEls, function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) {
            el.classList.add('is-visible');
          }
        });
      });

      // 保険B: 4秒後に全要素を表示(IOが沈黙した場合の最終防衛)
      window.setTimeout(showAll, 4000);
    } else {
      showAll();
    }
  }

  /* ---------------------------------------------------------
     2. Hero parallax (背景画像を 0.35x で流す)
     --------------------------------------------------------- */
  function initHeroParallax() {
    var heroBgs = document.querySelectorAll('.hero-bg');
    if (!heroBgs.length) return;

    var ticking = false;

    function onScrollHero() {
      var y = window.scrollY || window.pageYOffset;
      Array.prototype.forEach.call(heroBgs, function (bg) {
        var parent = bg.closest('.hero');
        if (!parent) return;
        var r = parent.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var offset = Math.max(0, -r.top) * 0.35;
        bg.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(onScrollHero);
      }
    }, { passive: true });

    onScrollHero();
  }

  /* ---------------------------------------------------------
     3. FAQ accordion
     <details> のネイティブ挙動を活かしつつ、開いたら他を閉じる
     --------------------------------------------------------- */
  function initFaq() {
    var faqItems = document.querySelectorAll('.faq__item');
    if (!faqItems.length) return;

    Array.prototype.forEach.call(faqItems, function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        Array.prototype.forEach.call(faqItems, function (other) {
          if (other !== item && other.open) {
            other.open = false;
          }
        });
      });
    });
  }

  /* ---------------------------------------------------------
     4. Smooth anchor scroll
     scrollIntoView は使わず、window.scrollTo で制御 (-24px)
     --------------------------------------------------------- */
  function initAnchorScroll() {
    var anchors = document.querySelectorAll('a[href^="#"]');
    Array.prototype.forEach.call(anchors, function (a) {
      a.addEventListener('click', function (ev) {
        var href = a.getAttribute('href');
        if (!href || href === '#' || href.length < 2) return;
        var target = document.querySelector(href);
        if (!target) return;
        ev.preventDefault();
        var top = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 24;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ---------------------------------------------------------
     5. 同梱制限スマート案内モーダル (Separate Shipping Modal)
     --------------------------------------------------------- */
  var conflictModal = null;

  function ensureConflictModal() {
    if (conflictModal) return conflictModal;
    var overlay = document.createElement('div');
    overlay.className = 'sk-kaki-conflict-overlay';
    overlay.id = 'sk-kaki-conflict-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'sk-kaki-conflict-title');
    overlay.innerHTML =
      '<div class="sk-kaki-conflict-dialog">' +
        '<span class="sk-kaki-conflict-icon" aria-hidden="true">📦</span>' +
        '<h3 class="sk-kaki-conflict-title" id="sk-kaki-conflict-title">お届け方法が異なるお品物です</h3>' +
        '<div class="sk-kaki-conflict-body">' +
          '<p>「佐渡産おけさ柿」は、最も美味しい状態でお届けするため<strong>佐渡島の産地農家より直接発送</strong>いたします。</p>' +
          '<p class="sk-kaki-conflict-note">現在カートに入っている他のお品物とは別便となるため、<strong>別々のお会計（個別注文）</strong>をお願いしております。</p>' +
        '</div>' +
        '<div class="sk-kaki-conflict-actions">' +
          '<button type="button" class="btn sk-kaki-conflict-btn sk-kaki-conflict-btn--primary" data-action="go-to-cart">' +
            '現在カートに入っている商品を先に購入する' +
          '</button>' +
          '<button type="button" class="btn sk-kaki-conflict-btn sk-kaki-conflict-btn--secondary" data-action="clear-and-add">' +
            'カートを空にして「おけさ柿」を購入する' +
          '</button>' +
          '<button type="button" class="sk-kaki-conflict-cancel" data-action="close-modal">' +
            '買い物を続ける（閉じる）' +
          '</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);
    conflictModal = overlay;

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('[data-action="close-modal"]')) {
        closeConflictModal();
      }
    });

    return conflictModal;
  }

  function showConflictModal(variantId, btn) {
    var modal = ensureConflictModal();
    var goToCartBtn = modal.querySelector('[data-action="go-to-cart"]');
    var clearAndAddBtn = modal.querySelector('[data-action="clear-and-add"]');

    goToCartBtn.onclick = function () {
      window.location.href = '/cart';
    };

    clearAndAddBtn.onclick = function () {
      clearAndAddBtn.disabled = true;
      var originalBtnText = clearAndAddBtn.textContent;
      clearAndAddBtn.textContent = 'カート更新中...';

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      })
      .then(function () {
        closeConflictModal();
        clearAndAddBtn.disabled = false;
        clearAndAddBtn.textContent = originalBtnText;
        executeAddToCart(variantId, btn);
      })
      .catch(function () {
        window.location.href = '/cart';
      });
    };

    modal.classList.add('is-active');
  }

  function closeConflictModal() {
    if (conflictModal) {
      conflictModal.classList.remove('is-active');
    }
  }

  /* ---------------------------------------------------------
     6. Shopify Cart API 連携 (カート非同期追加 + ドロワーオープン)
     --------------------------------------------------------- */
  function executeAddToCart(variantId, btn) {
    if (!btn) return;
    btn.classList.add('is-loading');

    var formData = {
      items: [{
        id: parseInt(variantId, 10),
        quantity: 1
      }]
    };

    var cartApi = window.ShopifyCartAPI || window.cartApi;
    if (cartApi && (typeof cartApi.addItemToCart === 'function' || typeof cartApi.addItem === 'function')) {
      var addPromise = typeof cartApi.addItemToCart === 'function'
        ? cartApi.addItemToCart(parseInt(variantId, 10), 1)
        : cartApi.addItem(parseInt(variantId, 10), 1);

      addPromise
        .then(function () {
          btn.classList.remove('is-loading');
          if (typeof cartApi.openMiniCart === 'function') {
            cartApi.openMiniCart();
          } else if (typeof cartApi.openDrawer === 'function') {
            cartApi.openDrawer();
          }
        })
        .catch(function (err) {
          console.error('Cart add error:', err);
          btn.classList.remove('is-loading');
          var msg = (err && err.message) ? err.message : '';
          if (msg.indexOf('制限') !== -1 || msg.indexOf('同梱') !== -1 || msg.indexOf('条件') !== -1) {
            showConflictModal(variantId, btn);
          } else {
            alert(msg || 'カートへの追加に失敗しました。商品の在庫状況をご確認ください。');
          }
        });
    } else {
      // 標準 fetch フォールバック
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var errorMsg = (data && (data.description || data.message)) || 'カートへの追加に失敗しました。';
            throw new Error(errorMsg);
          }
          return data;
        });
      })
      .then(function () {
        btn.classList.remove('is-loading');
        // ミニカート更新イベントを発火
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: 1 } }));

        if (window.ShopifyCartAPI && typeof window.ShopifyCartAPI.openMiniCart === 'function') {
          window.ShopifyCartAPI.openMiniCart();
        } else if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
          window.cartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        console.error('Cart add error:', err);
        btn.classList.remove('is-loading');
        var msg = (err && err.message) ? err.message : '';
        if (msg.indexOf('制限') !== -1 || msg.indexOf('同梱') !== -1 || msg.indexOf('条件') !== -1) {
          showConflictModal(variantId, btn);
        } else {
          alert(msg || 'カートへの追加に失敗しました。商品ページからご確認ください。');
        }
      });
    }
  }

  function initAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="add-to-cart"]');
      if (!btn) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        // バリアントID未指定（リンクとして動作させたい場合等）
        var fallbackHref = btn.getAttribute('data-fallback-href');
        if (fallbackHref && fallbackHref !== '#') {
          window.location.href = fallbackHref;
        }
        return;
      }

      e.preventDefault();

      btn.classList.add('is-loading');

      // 1. カートの状態を確認（他商品との同梱制限・競合チェック）
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var hasOtherItems = cart && cart.items && cart.items.length > 0 && cart.items.some(function (item) {
            var title = (item.product_title || item.title || '').toLowerCase();
            var handle = (item.handle || '').toLowerCase();
            return title.indexOf('柿') === -1 && handle.indexOf('kaki') === -1;
          });

          if (hasOtherItems) {
            btn.classList.remove('is-loading');
            showConflictModal(variantId, btn);
            return;
          }

          executeAddToCart(variantId, btn);
        })
        .catch(function () {
          executeAddToCart(variantId, btn);
        });
    });
  }

  // 初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initHeroParallax();
      initFaq();
      initAnchorScroll();
      initAddToCart();
    });
  } else {
    initReveal();
    initHeroParallax();
    initFaq();
    initAnchorScroll();
    initAddToCart();
  }
})();

